import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';
import {
  glassSurfaceCss,
  glassBorderCss,
  glassCardShadowCss,
} from '../../Components/GlassPill/glassSurface';

/** Same glass as the service cards it stands in for. */
const Notice = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 36px 40px;
  border-radius: 32px;
  ${glassBorderCss}
  ${glassSurfaceCss}
  ${glassCardShadowCss}
  color: var(--colorWhite);
  font-family: var(--eposFontFamily);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.4px;
  text-align: center;
`;

/** Replaces the service-type cards while the venue is outside its opening hours. */
const ClosedNotice: FC = () => {
  const { i18n } = useI18n();
  return <Notice data-testid="epos-venue-closed">{i18n('Express.VenueClosed')}</Notice>;
};

export default memo(ClosedNotice);
